import {
  AGENT_MODEL_FA_ICON_CLASS,
} from '@/components/Messenger/agent/AgentModelControls';
import type { AgentChatModelOption, ChatModelId } from '@/components/Messenger/agent/agentChatSharedTypes';

export function AssistantModelMetaFooter({
  slot,
  chatModels,
}: {
  slot: ChatModelId;
  chatModels: AgentChatModelOption[];
}) {
  const label = chatModels.find((m) => m.id === slot)?.label ?? slot;
  return (
    <div className="chatAssistant__dmAssistantModelMeta" title={`${label} • Астра`}>
      <i className={AGENT_MODEL_FA_ICON_CLASS[slot]} aria-hidden />
      <span className="chatAssistant__dmAssistantModelMetaLabel">{label}</span>
      <span className="chatAssistant__dmAssistantModelMetaDot" aria-hidden>
        •
      </span>
      <span className="chatAssistant__dmAssistantModelMetaBrand">Астра</span>
    </div>
  );
}
